import React, { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import PrimarySidebar from "../PrimarySidebar/PrimarySidebar";
import veritis_img from "../assets/images/veritis-logo.svg";
import veritis_banner from "../assets/images/veritis-banner.webp";
import { Offcanvas, Button, Accordion, ListGroup, Badge, Form, Tab, Tabs, Modal } from "react-bootstrap";
import { IoMdAddCircleOutline } from "react-icons/io";
import { BiEditAlt, BiTrash } from "react-icons/bi";




// interface Modal1Props {
//   show: boolean;
//   handleClose: () => void;
//   handleDelete: () => void;
// }




const editServices = [
  {
    category: "Cloud Services",
    subModules: [
      "AWS",
      "Azure Design",
      "Google Cloud",
      "Public Relations",
      "Hybrid Cloud",
      "Cloud Operations",
      "Data Migration",
    ],
  },

  {
    category: "Marketing",
    subModules: [
      "Advertising",
      "Branding",
      "Direct Marketing",
      "Public Relations",
      "Market Research",
      "Marketing Strategy",
      "Media Planning & Buying",
      "Event Marketing",
      "Other Marketing",
      "Product Marketing",
      "Sports Marketing",
      "Event Management",
      "Fractional CMO Services",
    ],
  },
  {
    category: "Digital Marketing",
    subModules: [
      "SEO",
      "Content Marketing",
      "Social Media Marketing",
      "Email Marketing",
      "Affiliate Marketing",
      "Online Advertising",
      "Mobile Marketing",
      "Conversion Rate Optimization",
      "Influencer Marketing",
      "Other Digital Marketing",
    ],
  },
];







const CompanyProfile = () => {
  const [activeSection, setActiveSection] = useState("");

  const [expanded, setExpanded] = useState(null);
  const [newComments, setNewComments] = useState({});
  const [selectedTopic, setSelectedTopic] = useState("");

  const announcements = [
    {
      id: 1,
      title: "New Office Launch 🎉",
      date: "March 10, 2024",
      description:
        "We are excited to announce the opening of our new office in New York!",
      likes: 24,
      comments: [
        { user: "Tecol Group", text: "Amazing! Looking forward to visiting." },
        { user: "Telsa Inc", text: "Great news, congratulations!" },
      ],
    },
    {
      id: 2,
      title: "Annual Meetup 📅",
      date: "February 28, 2024",
      description: "Join us for our annual company meetup. Register now!",
      likes: 18,
      comments: [{ user: "Emma", text: "Can't wait for the event!" }],
    },
    {
      id: 3,
      title: "Product Update 🚀",
      date: "February 15, 2024",
      description: "Introducing new AI features in our product suite!",
      likes: 32,
      comments: [{ user: "Daniel", text: "This is a game changer!" }],
    },
  ];

  const toggleComments = (id) => {
    setExpanded(expanded === id ? null : id);
  };

  const handleCommentChange = (id, value) => {
    setNewComments({ ...newComments, [id]: value });
  };

  const addComment = (id) => {
    if (!newComments[id]) return;
    const updatedAnnouncements = announcements.map((ann) =>
      ann.id === id
        ? {
          ...ann,
          comments: [...ann.comments, { user: "You", text: newComments[id] }],
        }
        : ann
    );
    setNewComments({ ...newComments, [id]: "" });
  };

  const sectionRefs = {
    about: useRef(null),
    services: useRef(null),
    products: useRef(null),
    portfolio: useRef(null),
    awards: useRef(null),
    reviews: useRef(null),
    announcement: useRef(null),
    contact: useRef(null),
  };

  const scrollToSection = (ref) => {
    if (ref.current) {
      window.scrollTo({
        top: ref.current.offsetTop - 80,
        behavior: "smooth",
      });
    }
  };

  const handleScroll = () => {
    let sectionInView = "";
    const subHeader = document.querySelector(".sub-header-profile");

    Object.entries(sectionRefs).forEach(([name, ref]) => {
      const el = ref.current;
      if (el) {
        const rect = el.getBoundingClientRect();
        if (
          rect.top <= window.innerHeight * 0.4 &&
          rect.bottom >= window.innerHeight * 0.2
        ) {
          sectionInView = name;
        }
      }
    });

    if (sectionInView && sectionInView !== activeSection) {
      setActiveSection(sectionInView);
    }

    if (subHeader) {
      const offset = subHeader.offsetTop;
      if (window.scrollY > offset) {
        subHeader.classList.add("fixed-sub-header");
      } else {
        subHeader.classList.remove("fixed-sub-header");
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [activeSection]);







  const [showCanvas1, setShowCanvas1] = useState(false);
  const [showCanvas2, setShowCanvas2] = useState(false);
  const [showCanvas3, setShowCanvas3] = useState(false);
  const [showCanvas4, setShowCanvas4] = useState(false);
  const [showCanvas5, setShowCanvas5] = useState(false);
  const [showCanvas6, setShowCanvas6] = useState(false);
  const [showCanvas7, setShowCanvas7] = useState(false);
  const [selectedSubModules, setSelectedSubModules] = useState([]);



  const handleShow1 = () => setShowCanvas1(true);
  const handleClose1 = () => setShowCanvas1(false);
  const handleShow2 = () => setShowCanvas2(true);
  const handleClose2 = () => setShowCanvas2(false);
  const handleShow3 = () => setShowCanvas3(true);
  const handleClose3 = () => setShowCanvas3(false);
  const handleShow4 = () => setShowCanvas4(true);
  const handleClose4 = () => setShowCanvas4(false);
  const handleShow5 = () => setShowCanvas5(true);
  const handleClose5 = () => setShowCanvas5(false);
  const handleShow6 = () => setShowCanvas6(true);
  const handleClose6 = () => setShowCanvas6(false);
  const handleShow7 = () => setShowCanvas7(true);
  const handleClose7 = () => setShowCanvas7(false);



  const [showCanvas11, setShowCanvas11] = useState(false);
  const handleShow11 = () => setShowCanvas11(true);
  const handleClose11 = () => setShowCanvas11(false);

  const [showCanvas22, setShowCanvas22] = useState(false);
  const handleShow22 = () => setShowCanvas22(true);
  const handleClose22 = () => setShowCanvas22(false);



  const [showCanvas44, setShowCanvas44] = useState(false);
  const handleShow44 = () => setShowCanvas44(true);
  const handleClose44 = () => setShowCanvas44(false);


  const [showCanvas55, setShowCanvas55] = useState(false);
  const handleShow55 = () => setShowCanvas55(true);
  const handleClose55 = () => setShowCanvas55(false);



  const [showCanvas66, setShowCanvas66] = useState(false);
  const handleShow66 = () => setShowCanvas66(true);
  const handleClose66 = () => setShowCanvas66(false);




  const handleSelect = (category, subModule) => {
    setSelectedSubModules((prev) => {
      const exists = prev.some((item) => item.subModule === subModule);
      return exists ? prev.filter((item) => item.subModule !== subModule) : [...prev, { category, subModule }];
    });
  };

  const handleRemove = (subModule) => {
    setSelectedSubModules((prev) => prev.filter((item) => item.subModule !== subModule));
  };




  const addPlan = () => {
    setPlans([...plans, { name: '', price: '' }]);
  };

  const addFeature = () => {
    setFeatures([...features, '']);
  };

  const addFaq = () => {
    setFaqs([...faqs, { question: '', answer: '' }]);
  };



  const [plans, setPlans] = useState([{ name: '', price: '' }]);
  const [features, setFeatures] = useState(['']);
  const [faqs, setFaqs] = useState([{ question: '', answer: '' }]);





  const [showModal, setShowModal] = useState(false);

  const handleDelete = () => {
    console.log("Item Deleted!");
    setShowModal(false);
  };



  return (
    <div>
      <PrimarySidebar />
      <div className="js-pg-hg mt-5">
        <div className="container cp-container">
          <div className="row justify-content-center">
            <div className="col-lg-12">


            <div className="heading d-flex flex-column flex-md-row align-items-md-center justify-content-md-between">
  <div className="text-start ms-sm-5 ms-lg-0">
    <h4>Veritis Group Inc</h4>
  </div>
  <div className="pt-2 mt-2 mt-md-0 text-md-end text-start ms-sm-5">
    <NavLink
      to="/RequestOwnershipForm"
      className="btn text-primary btn-outline-primary me-3"
    >
      Claim This Page
    </NavLink>
    <NavLink
      to="https://www.veritis.com"
      target="_blank"
      className="btn btn-primary text-white"
    >
      Open Website
    </NavLink>
  </div>
</div>




              <div className="card shadow-sm border-0 mt-4 rounded-4">
                <div className="brand-img">
                  <img
                    src={veritis_banner}
                    className="card-img-top mx-auto"
                    alt="Veritis Banner"
                  />
                  <div className="brand-logo shadow-sm p-4">
                    <img
                      src={veritis_img}
                      className="card-img-top mx-auto"
                      alt="Veritis Logo"
                    />
                  </div>
                </div>




<div className="sub-header-profile shadow-sm py-3 px-3 d-none d-md-block">
  <div className="container">
    <div className="row">
      <div className="col-12">
        <div className="profile-menu nav justify-content-start">
          {Object.keys(sectionRefs).map((key) => {
            // Insert a space before capital letters (except the first one)
            const formattedKey = key.replace(/([A-Z])/g, " $1").trim();

            return (
              <div className="nav-item" key={key}>
                <a
                  href={`#${key}`}
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(sectionRefs[key]);
                  }}
                  className={`text-dark nav-link ${activeSection === key ? "active" : ""}`}
                >
                  {formattedKey.charAt(0).toUpperCase() + formattedKey.slice(1)}
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  </div>
</div>






                {/* Content Sections */}
                <section ref={sectionRefs.about} id="about" className="py-4">

                <div class="card-body px-5 brand-body">
                <div className="d-flex justify-content-end">
                            <div className="mx-3 pt-2">
                              <Button variant="outline-primary" className="text-primary me-3" onClick={handleShow7}>Edit</Button>
                            </div>
                </div>
                </div>


                  <div className="row">
                    <div className="col-sm-8">
                      <div class="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">

                        <div className="d-flex justify-content-between">
                          <div>
                            <h3 class="card-title">Veritis</h3>
                            <p class="card-text lead fs-5 fw-500 text-muted">
                              Irving, United State
                            </p>

                            <p class="card-text fw-500 text-muted">
                              US-based IT Services Provider: Cloud, DevOps, Digital
                              Transformation, Identity Management, and Artificial
                              Intelligence!
                            </p>

                            <p class="card-text text-muted">

                              Veritis is a leading IT consulting service and solution provider. They design, develop, and implement mission-critical solutions that help clients achieve strategic objectives. Their solutions address clients' unique challenges, leveraging Veritis' vast experience in IT consulting. The company delivers results-driven solutions for success, with expertise that enables businesses to thrive. Their team provides personalized support and guidance, driving digital transformation for clients. By staying at the forefront of technology, Veritis helps clients stay ahead of the competition. With a proven track record of success, Veritis is a trusted partner for businesses seeking to achieve their goals through technology.
                            </p>
                          </div>


                        </div>



                      </div>
                    </div>


                    <div className="col-sm-4">
                     <div class="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">
                      <div class="text-muted py-4">
                        <h5 className="border-bottom pb-3">Comany Info</h5>
                        <ul class="list-group-info">
                          <li class="list-group-info py-2">
                            <i class="bx bxs-flag me-1"></i> Founded in 2004
                          </li>
                          <li class="list-group-info py-2">
                            <i class="bx bxs-group me-1"></i> 100 - 150 people
                            in their team
                          </li>
                          <li class="list-group-info py-2">
                            <i class="bx bx-globe me-1"></i> English, Spanish
                          </li>
                          <li class="list-group-info py-2">
                            <i class="bx bx-badge-check me-1"></i> Member Since
                            2025
                          </li>
                        </ul>
                      </div>

                      <div class="text-muted py-4">
                        <h5 className="border-bottom pb-3">Contact Info</h5>
                        <ul class="list-group-info">
                          <li class="list-group-info py-2">
                            <i class="bx bxs-envelope me-1"></i>{" "}
                            info@veritis.com
                          </li>
                          <li class="list-group-info  py-2">
                            <i class="bx bxs-phone me-1"></i> +1 123-456-7890
                          </li>
                        </ul>
                      </div>
                    </div>
                    </div>
                  </div>
                </section>






                <section
                  ref={sectionRefs.services}
                  id="services"
                  className="py-4 border-top"
                >
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                          <div className="text-center text-md-start">
                            <h3 className="card-title">Services Provide</h3>
                            <p className="card-text lead fs-6 fw-500 text-muted pb-4">8 services offered by Veritis</p>
                          </div>


                          <div>
                            <div className="text-center text-md-end mt-3 mt-md-0">
                              <Button variant="outline-primary" className="text-primary me-3" onClick={handleShow1}>Edit/Add</Button>
                            </div>
                          </div>

                        </div>


                        <div className="d-flex mt-4 flex-wrap">
                          <div className="card py-3 me-3 p-4 mb-4 border">
                            <h5>Cloud Services</h5>
                            <p className="text-muted">
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bx-star"></i> (4.5)
                            </p>
                            <small className="text-muted">
                              Skills: AWS, Azure, GCP, Hybrid Cloud
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>Containerization Services</h5>
                            <p className="text-muted">
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i> (5.0)
                            </p>
                            <small className="text-muted">
                              Skills: Docker, Kubernetes, OpenShift
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>DevOps Services</h5>
                            <p className="text-muted">
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bx-star"></i> (4.7)
                            </p>
                            <small className="text-muted">
                              Skills: CI/CD, Jenkins, GitOps, Terraform
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>Digital Transformation Services</h5>
                            <p className="text-muted">
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bx-star"></i> (4.6)
                            </p>
                            <small className="text-muted">
                              Skills: AI/ML, RPA, Business Automation
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>
                              Identity and Access Management (IAM) Services
                            </h5>
                            <p className="text-muted">
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i> (5.0)
                            </p>
                            <small className="text-muted">
                              Skills: Okta, AWS IAM, Azure AD, SSO
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>Managed Infrastructure Services</h5>
                            <p className="text-muted">
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bx-star"></i> (4.5)
                            </p>
                            <small className="text-muted">
                              Skills: Server Management, Networking, ITSM
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>Managed IT Services</h5>
                            <p className="text-muted">
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i>
                              <i class="bx bxs-star"></i> (5.0)
                            </p>
                            <small className="text-muted">
                              Skills: IT Support, Help Desk, Cloud Operations
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>














                <section
                  ref={sectionRefs.services}
                  id="services"
                  className="py-4 border-top"
                >
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                          <div className="text-center text-md-start">
                            <h3 className="card-title">Services Seeking</h3>
                            <p className="card-text lead fs-6 fw-500 text-muted pb-4">8 services looking by Veritis</p>
                          </div>


                          <div>
                            <div className="text-center text-md-end mt-3 mt-md-0">
                              <Button variant="outline-primary" className="text-primary me-3" onClick={handleShow11}>Edit/Add</Button>
                            </div>
                          </div>

                        </div>


                        <div className="d-flex mt-4 flex-wrap">
                          <div className="card py-3 me-3 p-4 mb-4 border">
                            <h5>Architecture Services</h5>
                            <small className="text-muted">
                              Skills: AWS, Azure, GCP, Hybrid Cloud
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>Configuration Services</h5>
                            <small className="text-muted">
                              Skills: Docker, Kubernetes, OpenShift
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>Data Handling</h5>
                            <small className="text-muted">
                              Skills: CI/CD, Jenkins, GitOps, Terraform
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>AI Transformation Services</h5>
                            <small className="text-muted">
                              Skills: AI/ML, RPA, Business Automation
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>
                              System Security Services
                            </h5>
                            <small className="text-muted">
                              Skills: Okta, AWS IAM, Azure AD, SSO
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>Managed Infrastructure Services</h5>
                            <small className="text-muted">
                              Skills: Server Management, Networking, ITSM
                            </small>
                          </div>

                          <div className="card py-3 me-3 p-4 mb-4 shadow-sm">
                            <h5>Managed IT Services</h5>
                            <small className="text-muted">
                              Skills: IT Support, Help Desk, Cloud Operations
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>










                <section
                  ref={sectionRefs.products}
                  id="products"
                  className="py-4 border-top"
                >
                  <div className="row">
                    <div className="col-12">
                      <div className="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">

                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                          <div className="text-center text-md-start">
                            <h3 className="card-title">Products</h3>
                            <p className="card-text lead fs-6 fw-500 text-muted pb-4">
                              Our product suite includes custom software solutions and operations.
                            </p>
                          </div>


                          <div>
                            <div className="text-center text-md-end mt-3 mt-md-0">
                              <Button variant="outline-primary" className="text-primary mb-4" onClick={handleShow2}>Add New Product</Button>
                            </div>
                          </div>

                        </div>








                        <div className="col-md-12 col-sm-12 mb-4">
  <div className="card mx-2 mb-3 p-4 shadow-sm ls-profile rounded-4 card-hover">
    {/* Stack for mobile, row for larger screens */}
    <div className="d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start">
      <img
        src="https://cdn.iconscout.com/icon/free/png-256/free-jira-software-logo-icon-download-in-svg-png-gif-file-formats--brand-logos-company-pack-icons-7417030.png"
        alt=""
        className="mb-3 mb-md-0 me-md-3 border rounded p-3"
        width="100"
        height="100"
      />
      <div className="ps-md-2 w-100">
        {/* Stack title & icons for mobile */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center align-items-md-start">
          <h5 className="mb-1">
            <NavLink to="/" className="text-black text-decoration-none">
              Sage 50 Accounting
            </NavLink>
          </h5>
          <div className="action-icons d-flex gap-2 mt-2 mt-md-0">
            <span className="bg-transparent p-2 border rounded-2">
              <BiEditAlt
                className="text-secondary"
                style={{ cursor: "pointer" }}
                onClick={handleShow22}
              />
            </span>
            <span className="bg-transparent p-2 border rounded-2">
              <BiTrash
                className="text-secondary"
                style={{ cursor: "pointer" }}
                onClick={() => setShowModal(true)}
              />
            </span>
          </div>
        </div>

        <p className="text-muted pt-2 mb-4">
          Sage 50 Accounting is a desktop accounting software that helps small
          businesses manage their finances. It offers many features, including
          invoicing, bill pay, expense tracking, inventory management, and
          reporting. Sage 50 Accounting ...
        </p>

        {/* Stack for mobile, row for larger screens */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center align-items-md-start border-top pt-3 num-stat mt-3 w-100 gap-3">
          <div className="text-center text-md-start">
            <span className="text-muted">Starting Price</span> <br />
            <strong>$2.98 Per Month</strong>
          </div>
          <div className="text-center text-md-start">
            <span className="text-muted">Free Trial</span> <br />
            <strong>30 Days</strong>
          </div>
          <div className="text-center text-md-start">
            <span className="text-muted">Rating</span> <br />
            <strong>
              4.5{" "}
              <i className="bx bxs-star"></i>
              <i className="bx bxs-star"></i>
              <i className="bx bxs-star"></i>
              <i className="bx bxs-star"></i>
              <i className="bx bx-star"></i>
            </strong>
          </div>
          {/* Stack buttons for mobile, row for larger screens */}
          <div className="text-center text-md-start">
            <a
              href="/ProductDetailedPage"
              className="btn btn-sm py-2 px-3 btn-outline-primary text-primary me-2"
            >
              View Product
            </a>
            <a href="#" className="btn py-2 btn-primary px-3 btn-sm text-white">
              Visit Website
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>










<div className="col-md-12 col-sm-12 mb-4">
  <div className="card mx-2 mb-3 p-4 shadow-sm ls-profile rounded-4 card-hover">
    {/* Stack for mobile, row for larger screens */}
    <div className="d-flex flex-column flex-md-row align-items-center align-items-md-start text-center text-md-start">
      <img
        src="https://www.priority-software.com/wp-content/uploads/2023/06/cropped-fav.png"
        alt=""
        className="mb-3 mb-md-0 me-md-3 border rounded p-3"
        width="100"
        height="100"
      />
      <div className="ps-md-2 w-100">
        {/* Stack title & icons for mobile */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center align-items-md-start">
          <h5 className="mb-1">
            <NavLink to="/" className="text-black text-decoration-none">
              Sage 50 Accounting
            </NavLink>
          </h5>
          <div className="action-icons d-flex gap-2 mt-2 mt-md-0">
            <span className="bg-transparent p-2 border rounded-2">
              <BiEditAlt
                className="text-secondary"
                style={{ cursor: "pointer" }}
                onClick={handleShow22}
              />
            </span>
            <span className="bg-transparent p-2 border rounded-2">
              <BiTrash
                className="text-secondary"
                style={{ cursor: "pointer" }}
                onClick={() => setShowModal(true)}
              />
            </span>
          </div>
        </div>

        <p className="text-muted pt-2 mb-4">
          Sage 50 Accounting is a desktop accounting software that helps small
          businesses manage their finances. It offers many features, including
          invoicing, bill pay, expense tracking, inventory management, and
          reporting. Sage 50 Accounting ...
        </p>

        {/* Stack for mobile, row for larger screens */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-center align-items-md-start border-top pt-3 num-stat mt-3 w-100 gap-3">
          <div className="text-center text-md-start">
            <span className="text-muted">Starting Price</span> <br />
            <strong>$2.98 Per Month</strong>
          </div>
          <div className="text-center text-md-start">
            <span className="text-muted">Free Trial</span> <br />
            <strong>30 Days</strong>
          </div>
          <div className="text-center text-md-start">
            <span className="text-muted">Rating</span> <br />
            <strong>
              4.5{" "}
              <i className="bx bxs-star"></i>
              <i className="bx bxs-star"></i>
              <i className="bx bxs-star"></i>
              <i className="bx bxs-star"></i>
              <i className="bx bx-star"></i>
            </strong>
          </div>
          {/* Stack buttons for mobile, row for larger screens */}
          <div className="text-center text-md-start">
            <a
              href="/ProductDetailedPage"
              className="btn btn-sm py-2 px-3 btn-outline-primary text-primary me-2"
            >
              View Product
            </a>
            <a href="#" className="btn py-2 btn-primary px-3 btn-sm text-white">
              Visit Website
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>




                      </div>
                    </div>
                  </div>
                </section>







                <section
                  ref={sectionRefs.portfolio}
                  id="portfolio"
                  className="py-4 border-top"
                >
                  <div className="row">
                    <div className="col-12">
                      <div className="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">

                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                          <div className="text-center text-md-start">
                            <h3 className="card-title">Portfolio</h3>
                            <p className="card-text lead fs-6 fw-500 text-muted pb-2 pb-md-4">
                              Our portfolio showcases successful projects across
                              multiple industries.
                            </p>
                          </div>

                          <div>
                            <div className="text-center text-md-end mt-3 mt-md-0">
                              <Button variant="outline-primary" className="text-primary mb-4" onClick={handleShow3}>Add Portfolio</Button>
                            </div>
                          </div>

                        </div>


                        <div className="row">
                          {[...Array(4)].map((_, index) => (
                            <div className="col-md-6 mb-4" key={index}>



<div className="card mx-2 mb-3 p-4 shadow-sm ls-profile rounded-4 card-hover">
  <div className="d-flex flex-wrap align-items-center">
    {/* Portfolio Image */}
    <img
      src="https://seeklogo.com/images/I/intel-new-2020-logo-21ED2748DD-seeklogo.com.png"
      alt="Portfolio"
      className="border rounded p-3 me-3 img-fluid"
      width="100"
      height="100"
      style={{ maxWidth: "100px" }}
    />

    <div className="ps-0 flex-grow-1 w-100">
      {/* Portfolio Title */}
      <div className="d-flex justify-content-between align-items-center flex-wrap mt-3">
        <h5 className="mb-1 text-truncate">
          <NavLink to="/" className="text-black text-decoration-none">
            Intel Design Portfolio
          </NavLink>
        </h5>
        <div className="action-icons">
          <span className="bg-transparent p-2 border rounded-2">
            <BiTrash className="text-secondary" style={{ cursor: "pointer" }} onClick={() => setShowModal(true)} />
          </span>
        </div>
      </div>

      {/* Attached Document + Button */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mt-1">
        {/* Attached Document */}
        <div className="d-flex align-items-center w-100">
          <i className="bx bx-file me-2 text-primary"></i>
          <span className="text-muted text-truncate w-100">
            Portfolio_Document.pdf
          </span>
        </div>
      </div>

      {/* View Portfolio Button */}
      <a href="#" className="btn btn-sm btn-outline-primary text-primary px-3 mt-3">
        View
      </a>
    </div>
  </div>
</div>




                            </div>
                          ))}
                        </div>{" "}
                        {/* End of Portfolio Grid */}
                      </div>
                    </div>
                  </div>
                </section>






                <section
                  ref={sectionRefs.awards}
                  id="awards"
                  className="py-4 border-top"
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-12">
                        <div className="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">


                          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                            <div className="text-center text-md-start">
                              <h3 className="card-title">Awards & Recognitions</h3>
                              <p className="card-text lead fs-6 fw-500 text-muted pb-2 pb-md-4">
                                Recognized for excellence in IT services,
                                innovation, and customer satisfaction.
                              </p>
                            </div>

                            <div>
                              <div className="text-center text-md-end mt-3 mt-md-0">
                                <Button variant="outline-primary" className="text-primary mb-4" onClick={handleShow4}>Add Award</Button>
                              </div>
                            </div>

                          </div>



                          {/* Horizontal Scroll Wrapper */}
                          <div className="horizontal-scroll">
                            {[
                              {
                                name: "Best Innovation Award",
                                image:
                                  "https://www.veritis.com/wp-content/uploads/2023/06/2022-stevie.png",
                                date: "2023",
                              },
                              {
                                name: "Tech Excellence Award",
                                image:
                                  "https://www.veritis.com/wp-content/uploads/2023/09/globee_slider-304.png",
                                date: "2022",
                              },
                              {
                                name: "Customer Award",
                                image:
                                  "https://www.veritis.com/wp-content/uploads/2023/06/2023-stevie.png",
                                date: "2021",
                              },
                              {
                                name: "Cloud Innovation Award",
                                image:
                                  "https://www.veritis.com/wp-content/uploads/2024/05/great-place-work.png",
                                date: "2020",
                              },
                              {
                                name: "AI Excellence Award",
                                image:
                                  "https://www.veritis.com/wp-content/uploads/2024/08/steve-2024-299x300-1.png",
                                date: "2019",
                              },
                              {
                                name: "Industry Leader Award",
                                image:
                                  "https://www.veritis.com/wp-content/uploads/2024/03/Certification-of-Greath-Place-to-work.png",
                                date: "2018",
                              },
                            ].map((award, index) => (
                              <div key={index} className="mx-2">
                                <div
                                  className="card shadow-sm rounded-4 h-100 d-flex flex-column card-hover"
                                  style={{ width: "250px" }}
                                >
                                  <div className="text-center">
                                    <img
                                      src={award.image}
                                      alt={award.name}
                                      className="border-none rounded-top-4"
                                      style={{ height: "auto", width: "150px" }}
                                    />
                                  </div>

                                  <div className="mt-3 text-center p-3">
                                    <h5 className="mb-1">{award.name}</h5>
                                    <span className="text-muted small badge p-2 mt-3">
                                      {award.date}
                                    </span>

                                    <div className="action-icons pt-3">
                                      <span className="bg-transparent p-2 border rounded-2 me-2"><BiEditAlt className="text-secondary" style={{ cursor: "pointer" }} onClick={handleShow44} /></span>
                                      <span className="bg-transparent p-2 border rounded-2"><BiTrash className="text-secondary" style={{ cursor: "pointer" }} onClick={() => setShowModal(true)} /></span>
                                    </div>

                                  </div>

                                </div>
                              </div>
                            ))}
                          </div>{" "}
                          {/* End of Scrollable Section */}
                        </div>
                      </div>
                    </div>
                  </div>
                </section>







                <section
                  ref={sectionRefs.reviews}
                  id="reviews"
                  className="py-4 border-top"
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-12">
                        <div className="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">

                           <div className="text-center text-md-start">
                          <h3 className="card-title">Reviews</h3>
                          <p className="card-text lead fs-6 fw-500 text-muted pb-4">
                            Our clients praise our commitment to quality,
                            innovation, and customer service excellence.
                          </p>
                          {/* Horizontal Scroll Wrapper */}
                          <div className="horizontal-scroll">
                            {[
                              {
                                name: "John Doe",
                                date: "March 5, 2024",
                                rating: 5,
                                feedback:
                                  "Excellent service! Highly professional and exceeded expectations.",
                              },
                              {
                                name: "Emily Smith",
                                date: "February 22, 2024",
                                rating: 4,
                                feedback:
                                  "Great experience! The team was responsive and delivered on time.",
                              },
                              {
                                name: "Michael Brown",
                                date: "January 30, 2024",
                                rating: 5,
                                feedback:
                                  "Fantastic support and outstanding quality of work! Thank you so much...",
                              },
                              {
                                name: "Sarah Wilson",
                                date: "December 18, 2023",
                                rating: 4,
                                feedback:
                                  "Very happy with the results. Just a few minor improvements needed.",
                              },
                              {
                                name: "David Johnson",
                                date: "November 10, 2023",
                                rating: 5,
                                feedback:
                                  "Top-notch service! Will definitely work with them again I'm very happy.",
                              },
                              {
                                name: "Olivia Martinez",
                                date: "October 5, 2023",
                                rating: 3,
                                feedback:
                                  "Decent service, but the response time could be improved.",
                              },
                            ].map((review, index) => (
                              <div key={index} className="review-card">
                                <div className="card mx-2 p-4 shadow-sm ls-profile rounded-4 review-card-height">
                                  {/* User Profile Icon - Moved Above Name */}
                                  <div className="text-center">
                                    <img
                                      src="https://cdn-icons-png.flaticon.com/512/3177/3177440.png"
                                      alt="User"
                                      className="border rounded-circle p-2 mb-3"
                                      width="60"
                                      height="60"
                                    />
                                  </div>

                                  {/* User Details */}
                                  <div className="text-center">
                                    <h5 className="mb-1">{review.name}</h5>
                                    <span className="text-muted small">
                                      {review.date}
                                    </span>
                                  </div>

                                  {/* Star Rating */}
                                  <div className="text-center mt-2 text-warning">
                                    {"★".repeat(review.rating)}
                                    {"☆".repeat(5 - review.rating)}
                                  </div>

                                  {/* User Feedback */}
                                  <p className="mt-3 text-muted text-center">
                                    {review.feedback}
                                  </p>
                                </div>
                              </div>
                            ))}
                          </div>{" "}
                          {/* End of Scrollable Section */}
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                </section>





















                <section id="announcement" className="py-4 border-top">
                  <div className="container">
                    <div className="row">
                      <div className="col-12">
                        <div className="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">

                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
  <div className="text-center text-md-start">
    <h3 className="card-title">Announcements</h3>
    <p className="card-text lead fs-6 fw-500 text-muted pb-2 pb-md-4">
      Stay updated with the latest company news, events, and updates.
    </p>
  </div>

  <div className="text-center text-md-end mt-3 mt-md-0">
    <Button variant="outline-primary" className="text-primary mb-4" onClick={handleShow5}>
      Add Announcement
    </Button>
  </div>
</div>






                          {/* Announcement Cards */}
                          <div className="row">
                            {announcements.map((ann) => (
                              <div className="col-md-12 col-12" key={ann.id}>



<div className="card mx-2 p-4 mb-4 shadow-sm rounded-4 card-hover">
  <div className="d-flex justify-content-between align-items-center flex-column flex-md-row text-center text-md-start">
    <h5 className="mb-2 mb-md-1">{ann.title}</h5>
    <div className="action-icons d-flex mt-2 mt-md-0">
      <span className="bg-transparent p-2 border rounded-2 me-2">
        <BiEditAlt className="text-secondary" style={{ cursor: "pointer" }} onClick={handleShow55} />
      </span>
      <span className="bg-transparent p-2 border rounded-2">
        <BiTrash className="text-secondary" style={{ cursor: "pointer" }} onClick={() => setShowModal(true)} />
      </span>
    </div>
  </div>

  <span className="text-muted small">{ann.date}</span>
  <p className="mt-3">{ann.description}</p>

  {/* Reactions Section */}
  <div className="d-flex justify-content-between align-items-center flex-column flex-md-row text-center text-md-start">
    <span className="text-muted mb-2 mb-md-0">
      👍 {ann.likes} Likes &nbsp; 💬 {ann.comments.length} Comments
    </span>
    <button className="btn btn-sm btn-outline-primary text-primary" onClick={() => toggleComments(ann.id)}>
      {expanded === ann.id ? "Hide Comments" : "View Comments"}
    </button>
  </div>

  {/* Comments Section */}
  {expanded === ann.id && (
    <div className="mt-3">
      <ul className="list-unstyled">
        {ann.comments.map((comment, index) => (
          <li key={index} className="border-bottom py-2">
            <div className="d-flex align-items-start flex-column flex-md-row text-center text-md-start">
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e8/Tesla_logo.png/1024px-Tesla_logo.png"
                alt="User"
                className="border rounded-circle p-1 mb-2 mb-md-0 me-md-2"
                width="40"
                height="40"
              />
              <div>
                <strong>{comment.user}</strong>
                <span className="text-muted small d-block">{comment.timestamp}</span>
                <p className="mb-0">{comment.text}</p>
              </div>
            </div>
          </li>
        ))}
      </ul>

      {/* Write Comment Section */}
      <div className="input-group mt-2">
        <input
          type="text"
          className="form-control"
          placeholder="Write a comment..."
          value={newComments[ann.id] || ""}
          onChange={(e) => handleCommentChange(ann.id, e.target.value)}
        />
        <button className="btn btn-primary" onClick={() => addComment(ann.id)}>
          Send
        </button>
      </div>
    </div>
  )}
</div>




                              </div>
                            ))}
                          </div> {/* End of Announcement Grid */}
                        </div>
                      </div>
                    </div>
                  </div>
                </section>






















                <section
                  ref={sectionRefs.contact}
                  id="contact"
                  className="py-4 border-top"
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-12">
                        <div className="card-body px-lg-5 px-mg-5 px-sm-2 brand-body">


                          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                            <div className="text-center text-md-start">
                              <h3 className="card-title">Our Branches</h3>
                              <p className="card-text lead fs-6 fw-500 text-muted pb-2 pb-md-4">
                                Find our offices worldwide. Connect with our branch collaborations.
                              </p>
                            </div>

                            <div>
                              <div className="text-center text-md-end mt-3 mt-md-0">
                                <Button variant="outline-primary" className="text-primary mb-4" onClick={handleShow6}>Add Branch</Button>
                              </div>
                            </div>

                          </div>




                          <div className="row">
                            {[
                              {
                                country: "USA",
                                city: "New York",
                                address: "123 5th Ave, New York, NY 10001, USA",
                                logo: "https://media.licdn.com/dms/image/v2/C510BAQHna_dD9vpNKg/company-logo_200_200/company-logo_200_200/0/1630628710289/veritis_group_inc_logo?e=2147483647&v=beta&t=8UDgYse3wANLmwRZ5JUULSvEFt7tOwLR8mQjtHkiAc4",
                              },
                              {
                                country: "UK",
                                city: "London",
                                address: "456 Oxford St, London W1D 1AN, UK",
                                logo: "https://media.licdn.com/dms/image/v2/C510BAQHna_dD9vpNKg/company-logo_200_200/company-logo_200_200/0/1630628710289/veritis_group_inc_logo?e=2147483647&v=beta&t=8UDgYse3wANLmwRZ5JUULSvEFt7tOwLR8mQjtHkiAc4",
                              },
                              {
                                country: "India",
                                city: "Bangalore",
                                address:
                                  "789 MG Road, Bangalore, Karnataka 560001, India",
                                logo: "https://media.licdn.com/dms/image/v2/C510BAQHna_dD9vpNKg/company-logo_200_200/company-logo_200_200/0/1630628710289/veritis_group_inc_logo?e=2147483647&v=beta&t=8UDgYse3wANLmwRZ5JUULSvEFt7tOwLR8mQjtHkiAc4",
                              },
                            ].map((branch, index) => (
                              <div className="col-md-6 mb-4" key={index}>




<div className="card mx-2 mb-3 p-4 shadow-sm ls-profile rounded-4 card-hover">
  <div className="d-flex align-items-center flex-column flex-md-row text-center text-md-start">
    {/* Branch Logo */}
    <img
      src={branch.logo}
      alt="Branch Logo"
      className="border rounded p-3 mb-3 mb-md-0 me-md-3"
      width="100"
      height="100"
    />

    <div className="ps-md-2 w-100">
      {/* Branch Info */}
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row text-center text-md-start">
        <h5 className="mb-2 mb-md-3 text-black">{branch.city}, {branch.country}</h5>
        <div className="action-icons d-flex">
          <span className="bg-transparent p-2 border rounded-2 me-2">
            <BiEditAlt className="text-secondary" style={{ cursor: "pointer" }} onClick={handleShow66} />
          </span>
          <span className="bg-transparent p-2 border rounded-2">
            <BiTrash className="text-secondary" style={{ cursor: "pointer" }} onClick={() => setShowModal(true)} />
          </span>
        </div>
      </div>

      <p className="text-muted mb-1">{branch.address}</p>
      <p className="fw-600 text-primary">Get Location Map</p>
    </div>
  </div>
</div>




                              </div>
                            ))}
                          </div>{" "}
                          {/* End of Branch Grid */}
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>










      <Offcanvas show={showCanvas1} onHide={handleClose1} placement="end" id="canvas-services" style={{ width: "680px" }}>
        <Offcanvas.Header closeButton className="px-5 py-4 bg-skyblue border-bottom">
          <Offcanvas.Title className="w-100 text-start fw-600">Add/Edit Providing Services</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="px-5 py-4 bg-light">
          <div className="p-5 rounded-4 card mb-4">
            <h4 className="mb-2">Select Categories</h4>
            <p className="mb-4">Select the services your company offers.</p>
            <Accordion className="ld-list-group" defaultActiveKey="0">
              {editServices.map((service, index) => (
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Accordion.Header>{service.category}</Accordion.Header>
                  <Accordion.Body>
                    <ListGroup variant="flush">
                      {service.subModules.map((subModule, subIndex) => {
                        const isSelected = selectedSubModules.some(item => item.subModule === subModule);
                        return (
                          <ListGroup.Item
                            key={subIndex}
                            action
                            onClick={() => handleSelect(service.category, subModule)}
                            active={isSelected}
                            className="d-flex justify-content-between align-items-center"
                          >
                            {subModule}
                            {isSelected && <i className="bx bxs-check-circle text-primary"></i>}
                            {/* Bootstrap Icons: Use 'bx bx-check-circle' OR FontAwesome 'fa fa-check-circle' */}
                          </ListGroup.Item>
                        );
                      })}
                    </ListGroup>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>

          <div className="mt-3 border rounded-4 mt-lg-0">
            <div className="border-bottom p-4 px-5">
              <h4 className="mb-2">Selected</h4>
              <p className="m-0 p-0">You added <strong>{selectedSubModules.length}</strong> Services</p>
            </div>
            <div className="p-4 card rounded-4 rounded-top-0 pt-2 px-5">
              {selectedSubModules.length > 0 ? (
                Object.entries(
                  selectedSubModules.reduce((acc, { category, subModule }) => {
                    acc[category] = acc[category] || [];
                    acc[category].push(subModule);
                    return acc;
                  }, {})
                ).map(([category, subModules], index) => (
                  <div key={index} className="mb-3">
                    <h5 className="mt-4 mb-3">{category}</h5>
                    {subModules.map((subModule, subIndex) => (
                      <Badge
                        key={subIndex}
                        className="badge rounded-pill text-primary px-3 bg-white mb-2 me-2"
                        onClick={() => handleRemove(subModule)}
                        style={{ cursor: 'pointer' }}
                      >
                        {subModule} &times;
                      </Badge>
                    ))}
                  </div>
                ))
              ) : (
                <div className="text-center text-secondary p-4">
                  <i className="bx bxs-briefcase bx-lg"></i>
                  <p className="mt-2">No services selected.</p>
                </div>
              )}

              <Button as={NavLink} to="/CompanyProfile" className="btn btn-primary rounded-3 fw-regular py-2 px-4">Update Providing Services</Button>
            </div>


          </div>
        </Offcanvas.Body>
      </Offcanvas>

















      {/* Service Seeking */}
      <Offcanvas show={showCanvas11} onHide={handleClose11} placement="end" id="canvas-services" style={{ width: "680px" }}>
        <Offcanvas.Header closeButton className="px-5 py-4 bg-skyblue border-bottom">
          <Offcanvas.Title className="w-100 text-start fw-600">Add/Edit Seeking Services</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="px-5 py-4 bg-light">
          <div className="p-5 rounded-4 card mb-4">
            <h4 className="mb-2">Select Categories</h4>
            <p className="mb-4">Select the services your company seeking.</p>
            <Accordion className="ld-list-group" defaultActiveKey="0">
              {editServices.map((service, index) => (
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Accordion.Header>{service.category}</Accordion.Header>
                  <Accordion.Body>
                    <ListGroup variant="flush">
                      {service.subModules.map((subModule, subIndex) => {
                        const isSelected = selectedSubModules.some(item => item.subModule === subModule);
                        return (
                          <ListGroup.Item
                            key={subIndex}
                            action
                            onClick={() => handleSelect(service.category, subModule)}
                            active={isSelected}
                            className="d-flex justify-content-between align-items-center"
                          >
                            {subModule}
                            {isSelected && <i className="bx bxs-check-circle text-primary"></i>}
                            {/* Bootstrap Icons: Use 'bx bx-check-circle' OR FontAwesome 'fa fa-check-circle' */}
                          </ListGroup.Item>
                        );
                      })}
                    </ListGroup>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>

          <div className="mt-3 border rounded-4 mt-lg-0">
            <div className="border-bottom p-4 px-5">
              <h4 className="mb-2">Selected</h4>
              <p className="m-0 p-0">You added <strong>{selectedSubModules.length}</strong>Seeking Services</p>
            </div>
            <div className="p-4 card rounded-4 rounded-top-0 pt-2 px-5">
              {selectedSubModules.length > 0 ? (
                Object.entries(
                  selectedSubModules.reduce((acc, { category, subModule }) => {
                    acc[category] = acc[category] || [];
                    acc[category].push(subModule);
                    return acc;
                  }, {})
                ).map(([category, subModules], index) => (
                  <div key={index} className="mb-3">
                    <h5 className="mt-4 mb-3">{category}</h5>
                    {subModules.map((subModule, subIndex) => (
                      <Badge
                        key={subIndex}
                        className="badge rounded-pill text-primary px-3 bg-white mb-2 me-2"
                        onClick={() => handleRemove(subModule)}
                        style={{ cursor: 'pointer' }}
                      >
                        {subModule} &times;
                      </Badge>
                    ))}
                  </div>
                ))
              ) : (
                <div className="text-center text-secondary p-4">
                  <i className="bx bxs-briefcase bx-lg"></i>
                  <p className="mt-2">No seeking services selected.</p>
                </div>
              )}

              <Button as={NavLink} to="/CompanyProfile" className="btn btn-primary rounded-3 fw-regular py-2 px-4">Update Seeking Services</Button>
            </div>


          </div>
        </Offcanvas.Body>
      </Offcanvas>













      {/* Product Canvas */}
      <Offcanvas
        show={showCanvas2}
        onHide={handleClose2}
        placement="end"
        id="canvas-product"
        className="shadow-lg"
        style={{ width: "680px" }}
      >
        <Offcanvas.Header
          closeButton
          className="px-5 py-4 bg-skyblue border-bottom"
        >
          <Offcanvas.Title className="w-100 text-start fw-600">
            Add New Product
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="px-5 py-4 bg-light">
          <Form className="py-3">
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">Product Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter product name"
                className="rounded-3"
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">Product Category</Form.Label>
              <Form.Select className="rounded-3">
                <option value="">Select Category</option>
                <option value="Software">Software</option>
                <option value="Accounting">Accounting</option>
                <option value="HR">HR</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">Product Countries</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter countries (e.g., India, USA)"
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                List countries separated by commas
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">Upload Logo</Form.Label>
              <Form.Control
                type="file"
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Recommended size: 300x300px (JPG, PNG)
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">Product Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter product description"
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Max 500 characters recommended
              </Form.Text>
            </Form.Group>

            <Accordion className="mb-4" defaultActiveKey="">
              <Accordion.Item eventKey="0" className="border-0 mb-3 rounded-3">
                <Accordion.Header className="bg-primary-subtle text-primary fw-semibold">
                  Plans
                </Accordion.Header>
                <Accordion.Body className="pt-4">
                  {plans.map((plan, index) => (
                    <div key={index} className="d-flex gap-3 mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Plan Name (e.g., Basic)"
                        className="rounded-3"
                      />
                      <Form.Control
                        type="text"
                        placeholder="Price per month (e.g., $10)"
                        className="rounded-3"
                      />
                    </div>
                  ))}
                  <Button
                    variant="outline-primary"
                    className="px-4 py-2 rounded-3 fw-semibold text-primary"
                    onClick={addPlan}
                  >
                    + Add More
                  </Button>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1" className="border-0 mb-3 rounded-3">
                <Accordion.Header className="bg-primary-subtle text-primary fw-semibold">
                  Key Features
                </Accordion.Header>
                <Accordion.Body className="pt-4">
                  {features.map((feature, index) => (
                    <Form.Control
                      key={index}
                      type="text"
                      placeholder="Feature (e.g., AI Insights)"
                      className="mb-3 rounded-3"
                    />
                  ))}
                  <Button
                    variant="outline-primary"
                    className="px-4 py-2 rounded-3 fw-semibold text-primary"
                    onClick={addFeature}
                  >
                    + Add More
                  </Button>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2" className="border-0 mb-3 rounded-3">
                <Accordion.Header className="bg-primary-subtle text-primary fw-semibold">
                  FAQ
                </Accordion.Header>
                <Accordion.Body className="pt-4">
                  {faqs.map((faq, index) => (
                    <div key={index} className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Question (e.g., What is this product?)"
                        className="mb-2 rounded-3"
                      />
                      <Form.Control
                        type="text"
                        placeholder="Answer"
                        className="rounded-3"
                      />
                    </div>
                  ))}
                  <Button
                    variant="outline-primary"
                    className="px-4 py-2 rounded-3 fw-semibold text-primary"
                    onClick={addFaq}
                  >
                    + Add More
                  </Button>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <Button
              variant="primary"
              type="submit"
              className="w-100 py-2 mt-4 rounded-3 fw-semibold"
            >
              Create Product
            </Button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>















      {/* Product Canvas Edit */}
      <Offcanvas
        show={showCanvas22}
        onHide={handleClose22}
        placement="end"
        id="canvas-product"
        className="shadow-lg"
        style={{ width: "680px" }}
      >
        <Offcanvas.Header
          closeButton
          className="px-5 py-4 bg-skyblue border-bottom"
        >
          <Offcanvas.Title className="w-100 text-start fw-600">
            Edit Product
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="px-5 py-4 bg-light">
          <Form className="py-3">
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">Product Name</Form.Label>
              <Form.Control
                type="text"
                value="Fitbase"
                className="rounded-3"
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">Product Category</Form.Label>
              <Form.Select className="rounded-3">
                <option value="">Select Category</option>
                <option value="Software">Software</option>
                <option value="Accounting">Accounting</option>
                <option value="HR">HR</option>
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">Product Countries</Form.Label>
              <Form.Control
                type="text"
                value="India, USA"
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                List countries separated by commas
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">Upload Logo</Form.Label>
              <Form.Control
                type="file"
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Recommended size: 300x300px (JPG, PNG)
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">Product Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value="Fitbase is a comprehensive health and wellness platform offering fitness tracking, personalized workout plans, and expert nutrition guidance. It integrates AI-driven insights to help users achieve their fitness goals efficiently. With an intuitive interface, Fitbase ensures a seamless experience for individuals, trainers, and organizations."
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Max 500 characters recommended
              </Form.Text>
            </Form.Group>

            <Accordion className="mb-4" defaultActiveKey="">
              <Accordion.Item eventKey="0" className="border-0 mb-3 rounded-3">
                <Accordion.Header className="bg-primary-subtle text-primary fw-semibold">
                  Plans
                </Accordion.Header>
                <Accordion.Body className="pt-4">
                  {plans.map((plan, index) => (
                    <div key={index} className="d-flex gap-3 mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Plan Name (e.g., Basic)"
                        className="rounded-3"
                      />
                      <Form.Control
                        type="text"
                        placeholder="Price per month (e.g., $10)"
                        className="rounded-3"
                      />
                    </div>
                  ))}
                  <Button
                    variant="outline-primary"
                    className="px-4 py-2 rounded-3 fw-semibold text-primary"
                    onClick={addPlan}
                  >
                    + Add More
                  </Button>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1" className="border-0 mb-3 rounded-3">
                <Accordion.Header className="bg-primary-subtle text-primary fw-semibold">
                  Key Features
                </Accordion.Header>
                <Accordion.Body className="pt-4">
                  {features.map((feature, index) => (
                    <Form.Control
                      key={index}
                      type="text"
                      placeholder="Feature (e.g., AI Insights)"
                      className="mb-3 rounded-3"
                    />
                  ))}
                  <Button
                    variant="outline-primary"
                    className="px-4 py-2 rounded-3 fw-semibold"
                    onClick={addFeature}
                  >
                    + Add More
                  </Button>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2" className="border-0 mb-3 rounded-3">
                <Accordion.Header className="bg-primary-subtle text-primary fw-semibold">
                  FAQ
                </Accordion.Header>
                <Accordion.Body className="pt-4">
                  {faqs.map((faq, index) => (
                    <div key={index} className="mb-3">
                      <Form.Control
                        type="text"
                        placeholder="Question (e.g., What is Fitbase?)"
                        className="mb-2 rounded-3"
                      />
                      <Form.Control
                        type="text"
                        placeholder="Answer"
                        className="rounded-3"
                      />
                    </div>
                  ))}
                  <Button
                    variant="outline-primary"
                    className="px-4 py-2 rounded-3 fw-semibold text-primary"
                    onClick={addFaq}
                  >
                    + Add More
                  </Button>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <Button
              variant="primary"
              type="submit"
              className="w-100 py-2 mt-4 rounded-3 fw-semibold"
            >
              Update Product
            </Button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>















      {/* New Portfolio Canvas */}
      <Offcanvas
        show={showCanvas3}
        onHide={handleClose3}
        placement="end"
        id="canvas-portfolio"
        className="shadow-lg bg-light"
        style={{ width: "680px" }}  // Using Bootstrap width class instead of inline style
      >
        <Offcanvas.Header
          closeButton
          className="px-5 py-4 bg-skyblue border-bottom"
        >
          <Offcanvas.Title className="fw-600">
            New Portfolio
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="px-5 py-4">
          <Form className="py-3">
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Portfolio Name
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter portfolio name"
                className="rounded-3"
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Upload Portfolio Image
              </Form.Label>
              <Form.Control
                type="file"
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Recommended size: 800x600px
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Upload File
              </Form.Label>
              <Form.Control
                type="file"
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Supported formats: PDF, DOC, JPG
              </Form.Text>
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100 py-2 mt-3 rounded-2 fw-semibold"
            >
              Create Portfolio
            </Button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>









      {/* New Awards Canvas */}
      <Offcanvas
        show={showCanvas4}
        onHide={handleClose4}
        placement="end"
        id="canvas-awards"
        className="shadow-lg"
        style={{ width: "680px" }}
      >
        <Offcanvas.Header
          closeButton
          className="px-5 py-4 bg-skyblue border-bottom"
        >
          <Offcanvas.Title className="fw-600">
            New Award
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="px-5 py-4 bg-light">
          <Form className="py-3">
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Award Name
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter award name"
                className="rounded-3"
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Year
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter year (e.g., 2023)"
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Enter a valid year (YYYY format)
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Upload Image
              </Form.Label>
              <Form.Control
                type="file"
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Recommended size: 600x400px (JPG, PNG)
              </Form.Text>
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100 py-2 mt-3 rounded-2 fw-semibold"
            >
              Add Award
            </Button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>










      {/* Announcements */}

      <Offcanvas
        show={showCanvas5}
        onHide={handleClose5}
        placement="end"
        id="canvas-announcements"
        className="shadow-lg"
        style={{ width: "680px" }}
      >
        <Offcanvas.Header
          closeButton
          className="px-5 py-4 bg-skyblue border-bottom"
        >
          <Offcanvas.Title className="fw-600">
            New Announcement
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="px-5 py-4 bg-light">


        <Form.Group>
            <Form.Label className="fw-semibold text-muted">
                Announcement
              </Form.Label>
            <Form.Select
              value={selectedTopic}
              onChange={(e) => setSelectedTopic(e.target.value)}
              className="mb-3 border rounded-2 p-2 w-100"
            >
              <option value="">Select</option>
              <option value="update">Product Update</option>
              <option value="update">Annual Meetup</option>
              <option value="Discussion">General</option>
              <option value="Event">Event</option>
              <option value="News">News</option>
            </Form.Select>
          </Form.Group>



          <Form className="py-3">
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Announcement Name
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter announcement name"
                className="rounded-3"
              />
            </Form.Group>



            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Announcement Description
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Enter announcement details"
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Provide a brief description (max 500 characters)
              </Form.Text>
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100 py-2 mt-3 rounded-2 fw-semibold"
            >
              Submit
            </Button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>









      {/* Add Branches Canvas */}
      <Offcanvas
        show={showCanvas6}
        onHide={handleClose6}
        placement="end"
        id="canvas-branches"
        className="shadow-lg"
        style={{ width: "680px" }}
      >
        <Offcanvas.Header
          closeButton
          className="px-5 py-4 bg-skyblue border-bottom"
        >
          <Offcanvas.Title className="fw-600">
            Add Branch
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="px-5 py-4 bg-light">
          <Form className="py-3">
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Company Logo
              </Form.Label>
              <Form.Control
                type="file"
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Recommended size: 300x300px (JPG, PNG)
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Address
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter branch address (e.g., 123 Main St)"
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Include full address with city and postal code
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Map Link
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter GPS map link (e.g., Google Maps URL)"
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Paste a valid map URL for location
              </Form.Text>
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100 py-2 mt-3 rounded-2 fw-semibold"
            >
              Submit
            </Button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>











      {/* edit profile canvas */}

      <Offcanvas
        show={showCanvas7}
        onHide={handleClose7}
        placement="end"
        id="canvas-edit-profile"
        className="shadow-lg"
        style={{ width: "680px" }}
      >
        <Offcanvas.Header
          closeButton
          className="px-5 py-4 bg-skyblue border-bottom"
        >
          <Offcanvas.Title className="w-100 text-start fw-600">
            Edit Profile
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="px-5 py-4 bg-light">
          <Tabs
            defaultActiveKey="about"
            id="edit-profile-tabs"
            className="mb-4 border-bottom-0"
            variant="pills"
            justify
          >
            {/* About Tab */}
            <Tab eventKey="about" title="About" className="pt-3">
              <Form className="p-3">
                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold text-muted">Company Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter company name"
                    required
                    className="rounded-3"
                  />
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold text-muted">Company Tagline (Optional)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter tagline"
                    className="rounded-3"
                  />
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold text-muted">Headquarters</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter address (e.g., 123 Main St)"
                    required
                    className="rounded-3"
                  />
                  <Form.Text className="text-muted">
                    Include full address with city and postal code
                  </Form.Text>
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold text-muted">Company Description (Optional)</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="Enter company description"
                    className="rounded-3"
                  />
                  <Form.Text className="text-muted">
                    Max 500 characters recommended
                  </Form.Text>
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold text-muted">Upload Logo</Form.Label>
                  <Form.Control
                    type="file"
                    className="rounded-3"
                  />
                  <Form.Text className="text-muted">
                    Recommended size: 300x300px (JPG, PNG)
                  </Form.Text>
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold text-muted">Upload Banner</Form.Label>
                  <Form.Control
                    type="file"
                    className="rounded-3"
                  />
                  <Form.Text className="text-muted">
                    Recommended size: 1200x400px (JPG, PNG)
                  </Form.Text>
                </Form.Group>
                <Button
                  variant="primary"
                  type="submit"
                  className="w-100 py-2 fw-semibold mt-3 rounded-3 shadow"
                >
                  Update Details
                </Button>
              </Form>
            </Tab>

            {/* Company Info Tab */}
            <Tab eventKey="company-info" title="Company Info" className="pt-3">
              <Form className="p-3">
                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold text-muted">Founded in (Optional)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter year (e.g., 2010)"
                    className="rounded-3"
                  />
                  <Form.Text className="text-muted">
                    Enter a valid year (YYYY format)
                  </Form.Text>
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold text-muted">Your Team</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter team size (e.g., 50-100)"
                    required
                    className="rounded-3"
                  />
                  <Form.Text className="text-muted">
                    Specify range or exact number
                  </Form.Text>
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold text-muted">Languages Spoken</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter languages (e.g., English, Spanish)"
                    required
                    className="rounded-3"
                  />
                  <Form.Text className="text-muted">
                    List languages separated by commas
                  </Form.Text>
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold text-muted">Annual Turnover (Optional)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter turnover (e.g., $1M)"
                    className="rounded-3"
                  />
                  <Form.Text className="text-muted">
                    Include currency if applicable
                  </Form.Text>
                </Form.Group>
                <Button
                  variant="primary"
                  type="submit"
                  className="w-100 py-2 fw-semibold mt-3 rounded-3"
                >
                  Update Details
                </Button>
              </Form>
            </Tab>

            {/* Contact Tab */}
            <Tab eventKey="contact" title="Contact" className="pt-3">
              <Form className="p-3">
                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold text-muted">Contact Mail</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter email (e.g., info@company.com)"
                    required
                    className="rounded-3 shadow-sm"
                  />
                </Form.Group>
                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold text-muted">Contact Phone Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter phone number (e.g., +1 123-456-7890)"
                    required
                    className="rounded-3 shadow-sm"
                  />
                  <Form.Text className="text-muted">
                    Include country code if applicable
                  </Form.Text>
                </Form.Group>
                <Button
                  variant="primary"
                  type="submit"
                  className="w-100 py-2 fw-semibold mt-3 rounded-3 shadow"
                >
                  Update Details
                </Button>
              </Form>
            </Tab>
          </Tabs>
        </Offcanvas.Body>
      </Offcanvas>







      {/* Edit Awards */}

      <Offcanvas
        show={showCanvas44}
        onHide={handleClose44}
        placement="end"
        id="canvas-awards"
        className="shadow-lg"
        style={{ width: "680px" }}
      >
        <Offcanvas.Header
          closeButton
          className="px-5 py-4 bg-skyblue border-bottom"  // Replaced bg-skyblue with bg-light
        >
          <Offcanvas.Title className="fw-600">
            Edit Award
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="px-5 py-4 bg-light">
          <Form className="py-3">
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Award Name
              </Form.Label>
              <Form.Control
                type="text"
                value="Globee Business Award"  // Set value instead of placeholder
                className="rounded-3"
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Year
              </Form.Label>
              <Form.Control
                type="text"
                value="2023"  // Set value instead of placeholder
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Enter a valid year (YYYY format)
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Upload Image
              </Form.Label>
              <Form.Control
                type="file"
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Current file: globeeaward.png | Recommended size: 600x400px (JPG, PNG)
              </Form.Text>
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100 py-2 mt-3 rounded-3 fw-semibold"
            >
              Update Award
            </Button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>








      {/* Edit Announcement */}

      <Offcanvas
        show={showCanvas55}
        onHide={handleClose55}
        placement="end"
        id="canvas-announcements"
        className="shadow-lg"
        style={{ width: "680px" }}  // Replaced inline width with Bootstrap class
      >
        <Offcanvas.Header
          closeButton
          className="px-5 py-4 bg-skyblue border-bottom"  // Replaced bg-skyblue with bg-light
        >
          <Offcanvas.Title className="fw-600">
            Edit Announcement
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="px-5 py-4 bg-light">


        <Form.Group>
            <Form.Label className="fw-semibold text-muted">
                Announcement
              </Form.Label>
            <Form.Select
              value={selectedTopic}
              onChange={(e) => setSelectedTopic(e.target.value)}
              className="mb-3 border rounded-2 p-2 w-100"
            >
              <option value="">Select</option>
              <option value="update">Product Update</option>
              <option value="update">Annual Meetup</option>
              <option value="Discussion">General</option>
              <option value="Event">Event</option>
              <option value="News">News</option>
            </Form.Select>
          </Form.Group>


          <Form className="py-3">
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Announcement Name
              </Form.Label>
              <Form.Control
                type="text"
                value="Annual Company Update 2025"  // Dummy data instead of placeholder
                className="rounded-3"
              />
            </Form.Group>




            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Announcement Description
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value="We are excited to share our annual company updates, including new product launches and team expansions scheduled for Q2 2025. Join us for a live session!"  // Dummy data
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Provide a brief description (max 500 characters)
              </Form.Text>
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100 py-2 mt-3 rounded-3 fw-semibold"
            >
              Update Details
            </Button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>








      {/* edit branch */}

      <Offcanvas
        show={showCanvas66}
        onHide={handleClose66}
        placement="end"
        id="canvas-branches"
        className="shadow-lg"
        style={{ width: "680px" }}
      >
        <Offcanvas.Header
          closeButton
          className="px-5 py-4 bg-skyblue border-bottom"  // Replaced bg-skyblue with bg-light
        >
          <Offcanvas.Title className="fw-600">
            Edit Branch
          </Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body className="px-5 py-4 bg-light">
          <Form className="py-3">
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Company Logo
              </Form.Label>
              <Form.Control
                type="file"
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Current file: branchlogo.png | Recommended size: 300x300px (JPG, PNG)
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Address
              </Form.Label>
              <Form.Control
                type="text"
                value="456 Oak Avenue, Suite 300, San Francisco, CA 94105"  // Dummy data
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Include full address with city and postal code
              </Form.Text>
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold text-muted">
                Map Link
              </Form.Label>
              <Form.Control
                type="text"
                value="https://maps.google.com/?q=456+Oak+Avenue,+San+Francisco,+CA+94105"  // Dummy data
                className="rounded-3"
              />
              <Form.Text className="text-muted">
                Paste a valid map URL for location
              </Form.Text>
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100 py-2 mt-3 rounded-3 fw-semibold"
            >
              Update Details
            </Button>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
        <Modal.Header closeButton className="bg-light border-bottom-0 pb-3">
          <Modal.Title className="w-100 text-center fw-600 text-primary">
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-5 text-center bg-light">
          <h4 className="fw-semibold mb-3 text-dark">
            Are you sure you want to delete it?
          </h4>
          <p className="text-muted mb-4 lead">
            Once you delete this, it can't be recovered. Please double-check your decision.
          </p>
          <div className="d-flex mt-4 justify-content-center gap-3 pb-4">
            <Button
              variant="outline-secondary"
              size="lg"
              className="px-4 py-2 rounded-3"
              onClick={() => setShowModal(false)}
            >
              No, Keep It
            </Button>
            <Button
              variant="danger"
              size="lg"
              className="px-4 py-2 rounded-3"
              onClick={handleDelete}
            >
              Yes, Delete It
            </Button>
          </div>
        </Modal.Body>
      </Modal>

    </div>

  );
};

export default CompanyProfile;
